import { useBannerSliderContext } from "@/components/BannerSlider/context/bannerSlider.context";

import { Base } from "./bannerSlider.base";
import { Controls } from "./components/controls/controls";
import { Slider } from "./components/slider/slider";

export const BannerSlider = Object.assign(Base, {
    useContext: useBannerSliderContext,
    Slider: Slider,
    Controls: Controls
});
